<template>
    <el-row style="margin:5px;">
        <el-col :xs="24" :sm="13" :md="12" :lg="11" :xl="10" class="tw-tablet-sob">
            <div style="background-color:white;">
                <el-table ref="refSobTable" style="width:100%;" border
                    :data="sobData" highlight-current-row @current-change="onCurrentChange"
                    :header-cell-style="{ background: '#fafafa' }">
                    <el-table-column type="index" width="35"></el-table-column>
                    <el-table-column prop="sob_no" width="80" label="账套编号"></el-table-column>
                    <el-table-column prop="sob_name" label="名称"></el-table-column>
                    <el-table-column prop="remember_me" width="100" label="记住登录状态"></el-table-column>
                    <el-table-column prop="expiry_date" width="100" label="有效期"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="150">
                        <template #default="scope">
                            <el-button @click="onEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="onDelete(scope.$index, scope.row)" type="text" size="small">删除</el-button>
                            <el-button @click="onOpenUser(scope.$index, scope.row)" type="text" size="small">用户权限</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-button icon="el-icon-circle-plus" style="margin:10px" @click="onAdd()" type="text" size="small">新增账套</el-button>
            </div>
        </el-col>
        <el-col :xs="24" :sm="11" :md="12" :lg="13" :xl="14" class="tw-tablet-power">
            <el-table ref="refPowerTable" :data="powerData" border style="width: 100%" row-key="id"
                :row-class-name="getRowClassName"
                :header-row-class-name="getHeaderRowClassName"
                :header-cell-style="{ background: '#fafafa' }"
                @select="onSelect"
                @select-all="onSelectAll">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="label" label="菜单" width="380"></el-table-column>
                <!-- <el-table-column prop="id" label="菜单ID" width="380"></el-table-column> -->
                <el-table-column prop="remark" label="说明"></el-table-column>
            </el-table>
        </el-col>
    </el-row>

    <!-- 用户对话框 -->
    <el-dialog :title="sobModel.index === -1 ? '新增账套' : `编辑账套 - ${sobData[sobModel.index]?.sob_name}`" v-model="dialogVisible">
        <el-form ref="refForm" :model="sobModel" :rules="rules" label-position="top" size="mini" label-width="80px">
            <el-form-item label="账套编号" prop="sob_no">
                <el-input style="width:30%" v-model="sobModel.sob_no"></el-input>
            </el-form-item>
            <el-form-item label="账套名称" prop="sob_name">
                <el-input style="width:60%" v-model="sobModel.sob_name"></el-input>
            </el-form-item>
            <el-form-item label="账套有效期" prop="expiry_date">
                <el-date-picker type="date" v-model="sobModel.expiry_date" :shortcuts="shortcuts" value-format="YYYY-MM-DD"></el-date-picker>
            </el-form-item>
            <el-form-item label="记住登录状态" prop="remember_me">
                <el-select v-model="sobModel.remember_me">
                    <el-option v-for="item in rememberMe" :key="item.name" :value="item.name" :label="item.caption">
                        <span style="float: left">{{ item.caption }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="ERP7服务器地址" prop="extend_data.server_url">
                <el-input v-model="sobModel.extend_data.server_url"></el-input>
            </el-form-item> -->
            <el-form-item label="备注" prop="remark">
                <el-input type="textarea" :rows="5" v-model="sobModel.remark"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="onConfirm">确 定</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'

// import systemService from '../../services/system.service'
import httpService from '../../services/http.service'

export default {
    name: 'tw-tablet-sobs',
    setup() {
        const router = useRouter()

        const sobData = ref([])
        const refSobTable = ref(null)
        const powerData = ref([])
        const refPowerTable = ref(null)
        let selectItems = new WeakMap()
        const currentRow = ref(null)

        const dialogVisible = ref(false)
        const sobModel = reactive({
            index: -1,  // -1 时新增，其余为编辑
            sob_no: '',
            sob_name: '',
            expiry_date: 'user',
            extend_data: {
                server_url: ''
            },
            remark: ''
        })

        const refForm = ref(null)
        const rules = {
            sob_no: [{ required: true, message: '请输入账套编号', trigger: 'blur' }],
            sob_name: [{ required: true, message: '请输入账套姓名', trigger: 'blur' }],
            expiry_date: [{ required: true, message: '请输入有效期', trigger: 'blur' }],
            "extend_data.server_url": [{ required: true, message: '请输入ERP服务器地址', trigger: 'blur' }]
        }

        const rememberMe = [
            { name: 'day', caption: '当天' },
            { name: 'week', caption: '本周' },
            { name: 'month', caption: '本月' },
            { name: 'year', caption: '本年' },
            { name: 'forever', caption: '永久' }
        ]

        powerData.value = [
            { selected: true, name: '开发打样', remark: '' },
            { selected: false, name: '销售查询', remark: '' },
            { selected: false, name: '供应查询', remark: '' },
        ]

        const onAdd = function() {
            Object.assign(sobModel, { index: -1, sob_no: '', sob_name: '', remember_me: 'day', expiry_date: '', extend_data: { server_url: '' }, remark: '' })
            dialogVisible.value = true
        }

        const onEdit = function(index, row) {
            Object.assign(sobModel, { index: index }, JSON.parse(JSON.stringify(row)))
            dialogVisible.value = true
        }

        const onDelete = function(index, row) {
            ElMessageBox.confirm(`确定要删除【${row.sob_no} - ${row.sob_name}】这个账套吗？`, '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                httpService.delete('admin-sob', { /* project_id: systemService.project_id, */ sob_no: row.sob_no }).then(() => {
                    sobData.value.splice(index, 1)
                    if (index < (sobData.value.length - 1)) {
                        refSobTable.value.setCurrentRow(sobData.value[index])
                    } else {
                        refSobTable.value.setCurrentRow(sobData.value[sobData.value.length - 1])
                    }
                }).catch(err => {
                    ElMessage.info({
                        showClose: true,
                        message: err.message
                    })
                })
            }).catch(() => {

            })
        }

        // 打开用户管理
        const onOpenUser = function(index, row) {
            router.push({ name: 'user', query: { sob_no: row.sob_no }})
        }

        const onConfirm = function() {
            refForm.value.validate((valid) => {
                if (valid) {
                    const sob = sobData.value.find((el, index) => el.sob_no === sobModel.sob_no && index !== sobModel.index)
                    if (!sob) {
                        const newSob = {
                            sob_no: sobModel.sob_no,
                            sob_name: sobModel.sob_name,
                            remember_me: sobModel.remember_me,
                            expiry_date: sobModel.expiry_date,
                            extend_data: { server_url: sobModel.extend_data.server_url },
                            remark: sobModel.remark
                        }

                        if (sobModel.index === -1) {
                            const params = { /* project_id: systemService.project_id */ }
                            httpService.post('admin-sobs', params, newSob).then(result => {
                                sobData.value.push(result)
                                refSobTable.value.setCurrentRow(sobData.value[sobData.value.length - 1])
                                dialogVisible.value = false
                            }).catch(err => {
                                ElMessage.info({
                                    showClose: true,
                                    message: err.message
                                })
                            })
                        } else {
                            const oldSob = sobData.value[sobModel.index]
                            const params = { /* project_id: systemService.project_id, */ sob_no: oldSob.sob_no }
                            httpService.put('admin-sob', params, newSob).then(result => {
                                sobData.value[sobModel.index] = result
                                refSobTable.value.setCurrentRow(sobData.value[sobModel.index])
                                dialogVisible.value = false
                            }).catch(err => {
                                ElMessage.info({
                                    showClose: true,
                                    message: err.message
                                })
                            })
                        }
                    } else {
                        ElMessage.info({
                            showClose: true,
                            message: `账套号 ${ sobModel.sob_no } 已存在！`
                        })
                    }
                }
            })
        }

        const onCurrentChange = function(value) {
            currentRow.value = value

            // 清除上一用户勾选项目
            selectItems = new WeakMap()
            refPowerTable.value.clearSelection()
            // 加载当前账套权限（勾选有权限的项目）
            if (value) {
                httpService.get('admin-sob-items', { /* project_id: systemService.project_id, */ sob_no: value.sob_no }).then(sobItems => {
                    const setSelectItems = function(items, powers) {
                        let selectCount = 0
                        for (let i = 0; i < items.length; i++) {
                            const item = items[i]
                            
                            let power = false
                            if (item.type === 'folder') {
                                // 文件夹下有项目且有权限时才要，否则连文件夹一起删除
                                if (item?.children?.length) {
                                    const isSelect = setSelectItems(item.children, powers)
                                    // 为 true 和 空字符 时为选中状态，否则为 false
                                    refPowerTable.value.toggleRowSelection(item, isSelect === false ? false : true)    
                                    selectItems.set(item, isSelect)
                                }
                            } else {
                                power = !!powers.find(el => el === item.id)
                                if (power) {
                                    selectCount++
                                    selectItems.set(item, true)
                                    refPowerTable.value.toggleRowSelection(item, true)
                                }
                            }
                        }

                        let isSelect = items.length === selectCount
                        if (!isSelect) {
                            if (selectCount === 0) {
                                isSelect = false
                            } else {
                                isSelect = ''
                            }
                        }

                        return isSelect
                    }

                    setSelectItems(powerData.value, sobItems)
                }).catch(err => {
                    ElMessage.info({
                        showClose: true,
                        message: err.message
                    })
                })
            }
        }

        const saveData = function() {
            if (currentRow.value) {
                const getSelectMenuIds = function(items) {
                    const result = []
                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        if (item.type === 'folder') {
                            const subResult = getSelectMenuIds(item.children)
                            result.push(...subResult)
                        } else {
                            const isSelect = selectItems.get(item)
                            if (isSelect && (item.type === 'page' || item.type === 'link')) {
                                result.push(item.id)
                            }
                        }
                    }
                    return result
                }

                const data = getSelectMenuIds(powerData.value)
                httpService.put('admin-sob-items', { /* project_id: systemService.project_id, */ sob_no: currentRow.value.sob_no }, data).then(() => {
                    
                }).catch(err => {
                    ElMessage.info({
                        showClose: true,
                        message: err.message
                    })
                })
            }
        }

        const onSelect = function(selection, row, isSave = true) {
            let isSelect = selectItems.get(row)
            //当点击父级点复选框时，当前的状态可能为未知状态，所以当前行状态设为false并选中，即可实现子级点全选效果
            if (isSelect === "") {
                isSelect = false
                refPowerTable.value.toggleRowSelection(row, true);
            }
            isSelect = !isSelect
            selectItems.set(row, isSelect)
            //判断操作的是子级点复选框还是父级点复选框，如果是父级点，则控制子级点的全选和不全选
            if (row.children && row.children.length > 0) {
                row.children.forEach(item => {
                    selectItems.set(item, isSelect)
                    refPowerTable.value.toggleRowSelection(item, isSelect);
                })
            } else {
                //操作的是子节点  1、获取父节点  2、判断子节点选中个数，如果全部选中则父节点设为选中状态，如果都不选中，则为不选中状态，如果部分选择，则设为不明确状态
                const item = row.parent    
                if (item) {
                    let isAllSelect = [];
                    item.children.forEach((childrenItem) => {
                        isAllSelect.push(selectItems.get(childrenItem) ?? false)
                    })
                    
                    if (isAllSelect.every(selectItem => selectItem === true)) {
                        // 全选中
                        selectItems.set(item, true)
                        refPowerTable.value.toggleRowSelection(item, true);
                    } else if (isAllSelect.every(selectItem => selectItem === false)) {
                        // 全未选
                        selectItems.set(item, false)
                        refPowerTable.value.toggleRowSelection(item, false);
                    } else {
                        // 不确定状态
                        selectItems.set(item, "")
                        refPowerTable.value.toggleRowSelection(item, true);
                    }
                }
            }

            if (isSave) {
                saveData()
            }
        }

        const onSelectAll = function(selection) {
            //判断一级节点是否是全选.如果全为true，则设置为取消全选，否则全选
            const selects = powerData.value.map(item => selectItems.get(item))
            const isAllSelect = selects.every(el => el === true)

            powerData.value.forEach(item => {
                selectItems.set(item, isAllSelect)
                refPowerTable.value.toggleRowSelection(item, !isAllSelect);
                onSelect(selection, item, false)
            })

            saveData()
        }

        const getRowClassName = function({ row }) {
            const isSelect = selectItems.get(row)
            if (isSelect === "") {
                return "indeterminate"
            }
        }

        const getHeaderRowClassName = function() {
            let oneProductIsSelect = []
            powerData.value.forEach(item => {
                oneProductIsSelect.push(selectItems.get(item))
            })
            if (oneProductIsSelect.includes("")) {
                return "indeterminate"
            }
            return ""
        }

        const shortcuts = [
            {
                text: '一个月',
                value: (() => {
                    const date = new Date()
                    date.setMonth(date.getMonth() + 1)
                    return date
                })()
            },
            { 
                text: '三个月', 
                value: (() => {
                    const date = new Date()
                    date.setMonth(date.getMonth() + 3)
                    return date
                })()
            },
            {
                text: '一年',
                value: (() => {
                    const date = new Date()
                    date.setMonth(date.getMonth() + 12)
                    return date
                })()
            },
            {
                text: '三年',
                value: (() => {
                    const date = new Date()
                    date.setMonth(date.getMonth() + 36)
                    return date
                })()
            }
        ]

        onMounted(() => {
            // 初始化菜单
            // 1、给子节点设置父节点，方便勾选权限时查找父节点
            const initMenus = function(items, parent) {
                for (let i = 0; i < items.length; i++) {
                    const item = items[i]
                    // 设置父节点
                    item.parent = parent

                    if (item.type === 'folder') {
                        // 文件夹下有项目且有权限时才要，否则连文件夹一起删除
                        if (item?.children?.length) {
                            initMenus(item.children, item)
                        }
                    }
                }
            }

            const menus = require('/public/static/menus.json')
            // 需要深复制，否则 initMenus 会修改到原始数据
            const items = JSON.parse(JSON.stringify(menus))
            initMenus(items)
            powerData.value = items

            // 需要加载完权限项才可以开始加载账套数据，因为需要勾选当前活动账套的权限项
            const params = { /* project_id: systemService.project_id */ }
            httpService.get('admin-sobs', params).then(result => {
                sobData.value = result
                if (sobData.value.length) {
                    refSobTable.value.setCurrentRow(sobData.value[0])
                }
            }).catch(err => {
                ElMessage.info({
                    showClose: true,
                    message: err.message
                })
            })
        })
        
        return {
            // 左边账套表相关
            refSobTable, sobData, rememberMe, onAdd, onEdit, onDelete, onCurrentChange, onOpenUser,
            // 右边权限表相关
            refPowerTable, powerData, onSelect, onSelectAll, getRowClassName, getHeaderRowClassName,
            // 编辑账套对话框相关
            refForm, rules, dialogVisible, sobModel, onConfirm, shortcuts
        }
    }
}
</script>

<style>
@media screen and (max-width: 775px) {
    .el-dialog {
        width: calc(100% - 10px * 2) !important;
        height: calc(100vh - 10px * 2) !important;
        margin: 10px !important;
    }
    .tw-tablet-sob>div {
        height: auto !important;
    }
    .tw-tablet-power {
        height: auto !important;
    }
}
.tw-tablet-sob {
    padding-right: 5px;
}
.tw-tablet-sob>div {
    height:calc(100vh - 70px);
}
.tw-tablet-power {
    height: calc(100vh - 70px);
    background-color: white;
}

/* 勾选框不确定状态样式 */
.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  content: "";
  position: absolute;
  display: block;
  background-color: #fff;
  height: 2px;
  transform: scale(0.5);
  left: 0;
  right: 0;
  top: 5px;
  width: auto !important;
}
</style>